import Phaser from 'phaser';
import { SceneKeys } from '../game/Constants';
import { GameState } from '../game/GameState';
import { SaveManager } from '../systems/SaveManager';
import { createTextButton } from '../ui/components/UIButton';
import { addBackButton, drawPanel, drawScreenBackground } from '../ui/components/SceneChrome';

export class SaveLoadScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.SaveLoad);
  }

  create() {
    this.render();
  }

  private render() {
    this.children.removeAll();
    drawScreenBackground(this, 'Save / Load', 'LocalStorage save slots for the Windows desktop build');
    if (GameState.instance.campaign) addBackButton(this);
    else createTextButton(this, { label: 'Back to Title', x: this.scale.width - 150, y: 48, width: 250, height: 42, fontSize: 18, onClick: () => this.scene.start(SceneKeys.Title) });

    drawPanel(this, 450, 500, 760, 690, 'Slots');
    const slots = SaveManager.instance.slots();
    if (!slots.length) {
      this.add.text(110, 180, 'No saves yet. Start a campaign and use manual save or end month autosave.', { fontFamily: 'Arial', fontSize: '18px', color: '#f2e3c2', wordWrap: { width: 620 } });
    }
    slots.forEach((metadata, index) => {
      const y = 170 + index * 92;
      this.add.rectangle(110 + 290, y + 28, 620, 72, 0x1b2430, 0.9).setStrokeStyle(2, 0x34495e);
      this.add.text(130, y, metadata.slot, { fontFamily: 'Georgia, serif', fontSize: '22px', color: '#f6e6bd' });
      this.add.text(130, y + 30, `${metadata.playerFactionName} - ${metadata.month}/${metadata.year} - Turn ${metadata.turn}`, { fontFamily: 'Arial', fontSize: '15px', color: '#d7b66f' });
      this.add.text(130, y + 52, new Date(metadata.savedAt).toLocaleString(), { fontFamily: 'Arial', fontSize: '13px', color: '#9fb3c8' });
      createTextButton(this, { label: 'Load', x: 590, y: y + 28, width: 110, height: 34, fontSize: 13, onClick: () => { if (SaveManager.instance.load(metadata.slot)) this.scene.start(SceneKeys.CampaignMap); } });
      createTextButton(this, { label: 'Delete', x: 705, y: y + 28, width: 110, height: 34, fontSize: 13, onClick: () => { SaveManager.instance.delete(metadata.slot); this.render(); } });
    });

    drawPanel(this, 1190, 500, 680, 690, 'Manual Save and Build Notes');
    if (GameState.instance.campaign) {
      createTextButton(this, { label: 'Save Slot 1', x: 1035, y: 200, width: 240, onClick: () => { SaveManager.instance.save('slot_1'); this.render(); } });
      createTextButton(this, { label: 'Save Slot 2', x: 1305, y: 200, width: 240, onClick: () => { SaveManager.instance.save('slot_2'); this.render(); } });
      createTextButton(this, { label: 'Autosave Now', x: 1170, y: 270, width: 280, onClick: () => { SaveManager.instance.save('autosave'); this.render(); } });
    } else {
      this.add.text(930, 180, 'Manual save is available after a campaign starts.', { fontFamily: 'Arial', fontSize: '17px', color: '#f2e3c2' });
    }
    this.add.text(900, 360, 'Updated docs in this build:\n- docs/ASSET_VALIDATION.md\n- docs/IMPLEMENTATION_LOG.md\n- docs/TECH_NOTES.md\n- docs/BALANCING_NOTES.md\n\nAsset import/update:\n1. Put new Manus assets in ../assets or starter asset drop folders.\n2. Run npm run asset-pipeline.\n3. Run npm run build.', {
      fontFamily: 'Arial',
      fontSize: '17px',
      color: '#f2e3c2',
      wordWrap: { width: 590 },
      lineSpacing: 8,
    });

    const exposed = window as unknown as { render_game_to_text?: () => string; advanceTime?: (ms: number) => void };
    exposed.render_game_to_text = () => JSON.stringify({ mode: 'save_load', slots: slots.map((slot) => slot.slot) });
    exposed.advanceTime = () => undefined;
  }
}
